import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from 'components/common/Loader';
import { selectIsAuthenticated, selectIsRestoring } from 'features/auth/authSelectors';
import { ROUTES } from 'constants/routes';

/**
 * Gate for authenticated areas. While the session is being restored (token in
 * storage, /me in flight) it shows a splash loader to avoid flashing the login
 * page. Unauthenticated users are redirected to login with a `from` location
 * so they can be returned after signing in.
 */
const ProtectedRoute = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isRestoring = useSelector(selectIsRestoring);
  const location = useLocation();

  if (isRestoring) return <Loader fullscreen label="Restoring session…" />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
